import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface NotificationStackProps {
  children?: ReactNode;
  className?: string;
}

export function NotificationStack({ children, className }: NotificationStackProps) {
  if (!children) return null;

  return (
    <div
      className={cn(
        'fixed z-[500] flex flex-col gap-2',
        'bottom-20 inset-x-4 md:bottom-4 md:left-4 md:inset-x-auto',
        'w-auto md:w-full md:max-w-sm',
        className,
      )}
    >
      {children}
    </div>
  );
}
